import userInfo from "../../function/userInfo";
import billingNoteHelper from "../../helper/billingNoteHelper";
import * as API from "../ApiConfig";
import { ConvertPaymentGroupForCreate, ConvertToSummaryAndCurrency } from "../transaction/transactionHelper";

export default {
  DoEditRemarkByTransaction(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        remark: input.remark,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/EditRemarkByTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReferenceNameByTransaction(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        referenceName: input.referenceName,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/EditReferenceNameByTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDueDateByTransaction(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        dueDate: input.dueDate,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Transaction/EditDueDateByTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#region EditTransactionDate
  DoEasyEditPurchaseRequisitionDate(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/EasyEditPurchaseRequisitionDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderDate(input) {
    let _input = {
      purchaseOrderId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderAssetDate(input) {
    let _input = {
      purchaseOrderAssetId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderAssetDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditQuotationDate(input) {
    let _input = {
      quotationId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditQuotationDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceDate(input) {
    let _input = {
      invoiceId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseInventoryDate(input) {
    let _input = {
      purchaseInventoryId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseInventoryDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceiptDate(input) {
    let _input = {
      receiptId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditCreditNoteDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/creditNote/EasyEditCreditNoteDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDebitNoteDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/debitNote/EasyEditDebitNoteDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditBillingNoteDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/EasyEditBillingNoteDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditDepositDate(input) {
    let _input = {
      depositId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditDepositDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceivedDepositDate(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditReceivedDepositDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region EditTransactionContact
  DoEasyEditPurchaseRequisitionContact(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/EasyEditPurchaseRequisitionContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderContact(input) {
    let _input = {
      purchaseOrderId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderAssetContact(input) {
    let _input = {
      purchaseOrderAssetId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderAssetContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditQuotationContact(input) {
    let _input = {
      quotationId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditQuotationContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceContact(input) {
    let _input = {
      invoiceId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseInventoryContact(input) {
    let _input = {
      purchaseInventoryId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseInventoryContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceiptContact(input) {
    let _input = {
      receiptId: input.transactionId,
      contactId: input.contactId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditCreditNoteContact(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        contactId: input.contactId,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/creditNote/EasyEditCreditNoteContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDebitNoteContact(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        contactId: input.contactId,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/debitNote/EasyEditDebitNoteContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditDepositContact(input) {
    let _input = {
      depositId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditDepositContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceivedDepositContact(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      contactId: input.contactId,
      isValidateCreditLimit: input.isValidateCreditLimit,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditReceivedDepositContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region EditTransactionNumber
  DoEasyEditPurchaseRequisitionNumber(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/EasyEditPurchaseRequisitionNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderNumber(input) {
    let _input = {
      purchaseOrderId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderAssetNumber(input) {
    let _input = {
      purchaseOrderAssetId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderAssetNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditQuotationNumber(input) {
    let _input = {
      quotationId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditQuotationNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceNumber(input) {
    let _input = {
      invoiceId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceSaleAssetNumber(input) {
    let _input = {
      invoiceSaleAssetId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceSaleAssetNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseInventoryNumber(input) {
    let _input = {
      purchaseInventoryId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseInventoryNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseAssetNumber(input) {
    let _input = {
      purchaseAssetId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseAssetNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceiptNumber(input) {
    let _input = {
      receiptId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceiptSaleAssetNumber(input) {
    let _input = {
      receiptSaleAssetId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptSaleAssetNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditTaxInvoiceNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/EasyEditTaxInvoiceNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditCreditNoteNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/creditNote/EasyEditCreditNoteNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDebitNoteNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/debitNote/EasyEditDebitNoteNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditBillingNoteNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/billingNote/EasyEditBillingNoteNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditDepositNumber(input) {
    let _input = {
      depositId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditDepositNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceivedDepositNumber(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      transactionNumber: input.transactionNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditReceivedDepositNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region EditProductAccountDescription
  DoEasyEditProductAccountDescriptionPurchaseRequisition(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
      productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/PurchaseRequisition/EasyEditProductAccountDescriptionPurchaseRequisition",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductAccountDescriptionPurchaseOrder(input) {
    let _input = {
      purchaseOrderId: input.transactionId,
      productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditProductAccountDescriptionPurchaseOrder", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductAccountDescriptionQuotation(input) {
    let _input = {
      quotationId: input.transactionId,
      productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditProductAccountDescriptionQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductAccountDescriptionInvoice(input) {
    let _input = {
      invoiceId: input.transactionId,
      productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditProductAccountDescriptionInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditAccountCodeAndDescriptionPurchaseInventory(input) {
    let _input = {
      purchaseInventoryId: input.transactionId,
      productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditAccountCodeAndDescriptionPurchaseInventory", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductAccountDescriptionReceipt(input) {
    let _input = {
      receiptId: input.transactionId,
      productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditProductAccountDescriptionReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductAccountDescriptionTaxInvoice(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/EasyEditProductAccountDescriptionTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductAccountDescriptionCreditNote(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/EasyEditProductAccountDescriptionCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductAccountDescriptionDebitNote(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/EasyEditProductAccountDescriptionDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductDescriptionDeposit(input) {
    let _input = {
      depositId: input.transactionId,
      productAccountCodeAndDescriptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditProductDescriptionDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditProductDescriptionReceivedDeposit(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      productAccountCodeAndDescriptionList: input.productAccountCodeAndDesciptions,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditProductDescriptionReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region EditPayment
  DoEasyEditPayment(input) {
    let _input = {
      data: {
        paymentGroup: ConvertPaymentGroupForCreate(input.paymentGroup),
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Payment/EasyEditPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPaymentDate(input) {
    let _input = {
      data: {
        paymentGroupId: input.paymentGroupId,
        paymentGroupDate: input.paymentDate,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Payment/EasyEditPaymentDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region EditWhtTransactionItem
  DoEditPurchaseRequisitionWhtTransactionItem(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      purchaseRequisitionId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post(
        "/api/PurchaseRequisition/EasyEditPurchaseRequisitionWhtTransactionItemById",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderWhtTransactionItem(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      purchaseOrderId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditPurchaseOrderAssetWhtTransactionItem(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      purchaseOrderAssetId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditPurchaseOrderAssetWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditQuotationWhtTransactionItem(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      quotationId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/EasyEditQuotationWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      invoiceId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceSaleAssetWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      invoiceSaleAssetId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditInvoiceSaleAssetWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseInventoryWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      purchaseInventoryId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseInventoryWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditPurchaseAssetWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      purchaseAssetId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/EasyEditPurchaseAssetWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceiptWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      receiptId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditReceiptSaleAssetWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      receiptSaleAssetId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/EasyEditReceiptSaleAssetWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditCreditNoteWhtTransactionItem(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      data: {
        transactionId: input.transactionId,
        productWhtList: input.productWhtList,
        transactionSummary: summaryAndCurrency.transactionSummary,
        transactionCurrency: summaryAndCurrency.transactionCurrency,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/EditCreditNoteWhtTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDebitNoteWhtTransactionItem(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      data: {
        transactionId: input.transactionId,
        productWhtList: input.productWhtList,
        transactionSummary: summaryAndCurrency.transactionSummary,
        transactionCurrency: summaryAndCurrency.transactionCurrency,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/EditDebitNoteWhtTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditBillingNoteTransactionItem(input) {
    let _input = {
      billingNoteId: input.billingNoteId,
      billingNoteTransactionList: billingNoteHelper.GetCreateBillingNoteTransactionList(
        input.billingNoteTransactionList
      ),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/EasyEditBillingNoteTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditDepositWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      depositId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditDepositWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceivedDepositWhtTransactionItemById(input) {
    let summaryAndCurrency = ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      receivedDepositId: input.transactionId,
      productWhtList: input.productWhtList,
      transactionSummary: summaryAndCurrency.transactionSummary,
      transactionCurrency: summaryAndCurrency.transactionCurrency,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/EasyEditReceivedDepositWhtTransactionItemById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
};
